import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from './design';
import { PublicLocale } from './routes';

export function ArticlePullQuote({ children, locale = 'sv' }: {
  children: React.ReactNode;
  locale?: PublicLocale;
}) {
  const opening = locale === 'en' ? '\u201c' : '\u201d';
  return <Box sx={{ my: 5, py: { xs: 4, md: 5 }, px: { xs: 3, md: 7 }, textAlign: 'center', bgcolor: colors.soft }}>
    <Typography component="p" sx={{ fontWeight: 700, fontSize: { xs: 20, md: 26 }, lineHeight: 1.35, color: `${colors.ink} !important`, maxWidth: 620, mx: 'auto' }}>
      {opening}{children}{'\u201d'}
    </Typography>
  </Box>;
}
